import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name : 'formatNumberWithSpace'})
export class FormatNumberWithSpace implements PipeTransform {
    transform(value: any, ...args: any[]): string {
        if (value === null)
            return '';
        value = +value;
        const parts = value.toFixed(2).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0");
        return parts.join(".");
    }
}
